/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-30 19:49:41
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-09 16:25:05
 */
import { TableColumnType } from "antd"

export const PrisonDataColumn = (): TableColumnType<any>[] => {
  return [
    {
      title: '卫健委(局)',
      dataIndex: 'osName',
      align: 'center',
      key: 'osName',
    },
    {
      title: '智能监管机构数',
      dataIndex: 'organizationTotal',
      align: 'center',
      key: 'organizationTotal',
      sorter: (a, b, sorter) => {
        if (sorter === 'ascend') {
          return a.osName === '合计'
            ? 1
            : a.organizationTotal - b.organizationTotal
        } else {
          return a.osName === '合计'
            ? -1
            : a.organizationTotal - b.organizationTotal
        }
      },
    },
    {
      title: '机构数（有诊疗）',
      dataIndex: 'validAcOrgTc',
      align: 'center',
      key: 'validAcOrgTc',
      sorter: (a, b, sorter) => {
        if (sorter === 'ascend') {
          return a.osName === '合计' ? 1 : a.validAcOrgTc - b.validAcOrgTc
        } else {
          return a.osName === '合计' ? -1 : a.validAcOrgTc - b.validAcOrgTc
        }
      },
    },
    {
      title: '诊疗数',
      dataIndex: 'medicalTotal',
      align: 'center',
      key: 'medicalTotal',
      sorter: (a, b, sorter) => {
        if (sorter === 'ascend') {
          return a.osName === '合计' ? 1 : a.medicalTotal - b.medicalTotal
        } else {
          return a.osName === '合计' ? -1 : a.medicalTotal - b.medicalTotal
        }
      },
    },
    {
      title: '预警数',
      dataIndex: 'cautionTotal',
      align: 'center',
      key: 'cautionTotal',
      sorter: (a, b, sorter) => {
        if (sorter === 'ascend') {
          return a.osName === '合计' ? 1 : a.cautionTotal - b.cautionTotal
        } else {
          return a.osName === '合计' ? -1 : a.cautionTotal - b.cautionTotal
        }
      },
    },
    {
      // title: "执法数",
      title: '处置数',
      dataIndex: 'handleTotal',
      align: 'center',
      key: 'handleTotal',
      sorter: (a, b, sorter) => {
        if (sorter === 'ascend') {
          return a.osName === '合计' ? 1 : a.handleTotal - b.handleTotal
        } else {
          return a.osName === '合计' ? -1 : a.handleTotal - b.handleTotal
        }
      },
    },
    {
      title: '预警占比',
      dataIndex: '',
      align: 'center',
      key: 't.cautionTotal / t.medicalTotal',
      render: (_, t) => {
        return t.cautionTotal === 0 || t.medicalTotal === 0
          ? '-'
          : ((t.cautionTotal / t.medicalTotal) * 100).toFixed(2) + '%'
      },
      sorter: (a, b, sorter) => {
        const valA = Math.round(
          (a.medicalTotal ? a.cautionTotal / a.medicalTotal : 0) * 1000
        )
        const valB = Math.round(
          (b.medicalTotal ? b.cautionTotal / b.medicalTotal : 0) * 1000
        )
        if (sorter === 'ascend') {
          return a.osName === '合计' ? 1 : valA - valB
        } else {
          return a.osName === '合计' ? -1 : valA - valB
        }
      },
    },
    {
      title: '处置占比',
      dataIndex: 'handleRatio',
      align: 'center',
      key: 't.handleTotal / t.cautionTotal',
      render: (_, t) => {
        return t.handleTotal === 0 || t.cautionTotal === 0
          ? '-'
          : ((t.handleTotal / t.cautionTotal) * 100).toFixed(2) + '%'
      },
      sorter: (a, b, sorter) => {
        const valA = Math.round(
          (a.handleTotal ? a.cautionTotal / a.handleTotal : 0) * 1000
        )
        const valB = Math.round(
          (b.handleTotal ? b.cautionTotal / b.handleTotal : 0) * 1000
        )
        if (sorter === 'ascend') {
          return a.osName === '合计' ? 1 : valA - valB
        } else {
          return a.osName === '合计' ? -1 : valA - valB
        }
      },
    },
  ]
}
